import { render, staticRenderFns } from "./BlockList.vue?vue&type=template&id=b4e2a606&"
import script from "./BlockList.vue?vue&type=script&lang=ts&"
export * from "./BlockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports